import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {organizationSettingsActions} from "_actions";

export default function useGetTrendsDataSourceHandles(organizationTrendsId) {
    const dispatch = useDispatch();

    useEffect(() => {
        if (organizationTrendsId) {
            dispatch(organizationSettingsActions.fetchTrendsDataSourceHandles(organizationTrendsId));
        }
    }, [organizationTrendsId]);

    const organizationSettings = useSelector(state => state.organizationSettings);
    const trendsHandles = organizationSettings.trendsHandles || [];
    const loading = organizationSettings.loadingTrendsHandles;

    return {trendsHandles, loading};
}
